<template>
  <ValidationProvider
    ref="validation"
    v-slot="{ errors, invalid, failed }"
    class="JoszakiInput mb-3"
    :class="{
      flex: hasAddons,
    }"
    slim
    :rules="rules"
    :vid="vid"
  >
    <slot name="label" :failed="failed" :invalid="invalid">
      <div v-if="label" class="mb-1 !text-left">
        <label class="block font-bold">{{ label }}</label>
      </div>
    </slot>
    <p class="relative">
      <template v-if="mask">
        <input
          ref="input"
          v-mask="mask"
          class="w-full bg-white border rounded text-gray-800 px-3 py-2 focus:outline-none focus:ring-1"
          :class="[
            failed
              ? 'border-error focus:border-error focus:ring-error'
              : 'border-gray-300 focus:border-info focus:ring-info',
            { 'pl-10': !!iconLeft, 'pr-10': failed || !!iconRight },
          ]"
          :type="type"
          :placeholder="placeholder"
          :value="value"
          :step="type === 'number' ? step ?? 1 : null"
          @input="onInput"
        />
      </template>
      <template v-else>
        <input
          ref="input"
          class="w-full bg-white border rounded text-gray-800 px-3 py-2 focus:outline-none focus:ring-1"
          :class="[
            failed
              ? 'border-error focus:border-error focus:ring-error'
              : 'border-gray-300 focus:border-info focus:ring-info',
            { 'pl-10': !!iconLeft, 'pr-10': failed || !!iconRight },
          ]"
          :type="type"
          :placeholder="placeholder"
          :value="value"
          :disabled="disabled"
          :step="type === 'number' ? step ?? 1 : null"
          @input="onInput"
          @focusout="(event) => $emit('focusout', event)"
          @focusin="(event) => $emit('focusin', event)"
        />
      </template>
      <span
        v-if="iconLeft"
        class="absolute left-0 top-0 h-full w-10 flex items-center justify-center text-gray-400 pointer-events-none"
      >
        <IconComponent :pack="iconPackLeft" :icon="iconLeft" />
      </span>
      <span
        v-if="failed || !!iconRight"
        class="absolute right-0 top-0 h-full w-10 flex items-center justify-center pointer-events-none"
      >
        <IconComponent
          :pack="iconPackRight"
          :icon="iconRight || 'exclamation-circle'"
          :class="{
            'text-error': failed && !iconRight,
          }"
        />
      </span>
    </p>
    <slot name="addons" />
    <p v-show="failed" class="text-sm text-error mt-1">
      {{ errors[0] }}
    </p>
  </ValidationProvider>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    value: {
      type: [String, Boolean, Number],
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    hasAddons: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
      // TODO add more as needed
      validator: (val) =>
        ["text", "email", "number", "tel", "checkbox", "password"].includes(
          val
        ),
    },
    iconLeft: {
      type: String,
      default: "",
    },
    iconPackLeft: {
      type: String,
      default: "fas",
    },
    iconRight: {
      type: String,
      default: "",
    },
    iconPackRight: {
      type: String,
      default: "fas",
    },
    placeholder: {
      type: String,
      default: "",
    },
    mask: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    immediate: {
      type: Boolean,
      default: false,
      description: "Whether or not input should be validated immediately",
    },
    vid: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: null,
    },
  },
  computed: {
    hasIconRight() {
      return this.isFailed() || !!this.iconRight;
    },
  },
  mounted() {
    if (this.immediate) {
      this.$refs.validation.validate();
    }
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit("input", value);
    },
    focus() {
      this.$refs.input.focus();
    },
    isFailed() {
      const validation = this.$refs.validation;
      return validation?.failed;
    },
  },
};
</script>
